var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAadhar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17582",
    "data-name": "Group 17582",
    transform: "translate(-632 -402)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_585",
    "data-name": "Ellipse 585",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(632 402)",
    fill: "#dfefec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17580",
    "data-name": "Group 17580",
    transform: "translate(-3328 14020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19533",
    "data-name": "Path 19533",
    d: "M14.133,34.089a.681.681,0,0,1-.681-.681,2.044,2.044,0,1,0-4.089,0,.681.681,0,0,1-1.363,0,3.407,3.407,0,1,1,6.815,0A.681.681,0,0,1,14.133,34.089Z",
    transform: "translate(3963.726 -13629.868)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19534",
    "data-name": "Path 19534",
    d: "M14.044,26.089a2.044,2.044,0,1,1,2.044-2.044A2.044,2.044,0,0,1,14.044,26.089Zm0-2.726a.681.681,0,1,0,.681.681A.681.681,0,0,0,14.044,23.363Z",
    transform: "translate(3961.089 -13625.267)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19535",
    "data-name": "Path 19535",
    d: "M38.133,23.363H32.681a.681.681,0,0,1,0-1.363h5.452a.681.681,0,0,1,0,1.363Z",
    transform: "translate(3947.222 -13624.6)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19536",
    "data-name": "Path 19536",
    d: "M36.285,31.363h-3.6a.681.681,0,0,1,0-1.363h3.6a.681.681,0,0,1,0,1.363Z",
    transform: "translate(3947.222 -13630.099)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19537",
    "data-name": "Path 19537",
    d: "M14.695,26.252H1.363V15.363H19.081v6.953a5.411,5.411,0,0,1,1.363.559V14.681A.681.681,0,0,0,19.763,14H.681A.681.681,0,0,0,0,14.681V26.934a.681.681,0,0,0,.681.681L14.695,27.6c-.246-.427.122-.866,0-1.344Z",
    transform: "translate(3969 -13620)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19538",
    "data-name": "Path 19538",
    d: "M44.089,38.178a4.089,4.089,0,1,1,4.089-4.089A4.089,4.089,0,0,1,44.089,38.178Zm0-6.815a2.726,2.726,0,1,0,2.726,2.726A2.726,2.726,0,0,0,44.089,31.363Z",
    transform: "translate(3942.854 -13628.3)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17579",
    "data-name": "Group 17579",
    transform: "translate(3984.859 -13596.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19539",
    "data-name": "Path 19539",
    d: "M3.407.8H.681C.305.8,0,.624,0,.4S.305,0,.681,0H3.407c.376,0,.681.18.681.4S3.784.8,3.407.8Z",
    transform: "translate(2.402 0) rotate(90)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19540",
    "data-name": "Path 19540",
    d: "M2.355.793H.471A.439.439,0,0,1,0,.4.439.439,0,0,1,.471,0L2.51.043c.26,0,.216.314.216.533S2.616.793,2.355.793Z",
    transform: "translate(4.143 2.615) rotate(141)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19541",
    "data-name": "Path 19541",
    d: "M2.355.8H.471A.44.44,0,0,1,0,.4.44.44,0,0,1,.471,0H2.355c.26,0,.381.258.381.479S2.616.8,2.355.8Z",
    transform: "translate(0.546 1.88) rotate(43)",
    fill: "#0c263d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhar);
export default __webpack_public_path__ + "static/media/aadhar.b600f734f3bcd94f23f8216f808ce8b4.svg";
export { ForwardRef as ReactComponent };